//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

const ThumbnailList = () => import(
/* webpackChunkName: "zoom-modal" */
'~/components/organisms/Product/ThumbnailList.vue');

const SquareImage = () => import(
/* webpackChunkName: "zoom-modal" */
'~/components/atoms/Product/SquareImage.vue');

export default {
  name: 'ZoomModal',
  components: {
    MdmModal,
    ThumbnailList,
    SquareImage
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    images: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      currentIndex: this.index,
      maxZoom: false,
      left: '0px',
      top: '0px'
    };
  },

  computed: {
    img() {
      return this.images[this.currentIndex];
    },

    zoomCursor() {
      return {
        cursor: this.maxZoom ? 'zoom-out' : 'zoom-in'
      };
    }

  },
  watch: {
    currentIndex(newValue) {
      if (newValue !== this.index) {
        this.$emit('update:index', newValue);
        this.resetZoom();
      }
    }

  },
  methods: {
    toggleMaxZoom(ev) {
      this.maxZoom = !this.maxZoom;
      this.$nextTick(() => this.moveZoom(ev));
    },

    resetZoom() {
      // Reset image position after moveZoom
      this.maxZoom = false;
      this.moveZoom();
    },

    moveZoom(ev) {
      if (!this.maxZoom || !ev) {
        this.left = '0px';
        this.top = '0px';
        return;
      }

      const {
        offsetHeight,
        offsetWidth
      } = this.$refs.maxZoomContainer;
      const {
        clientHeight,
        clientWidth
      } = this.$refs.maxZoomImage.$el;
      const ratioY = ev.clientY / offsetHeight;
      const ratioX = ev.clientX / offsetWidth;
      const left = Math.round((-clientWidth + offsetWidth) * ratioX);
      const top = Math.round((-clientHeight + offsetHeight) * ratioY);
      this.left = "".concat(left, "px");
      this.top = "".concat(top, "px");
    }

  }
};